import React, { createContext, useContext, useMemo, ReactNode } from 'react';
import { generateTournament } from '../utils/tournamentGenerator';
import { Tournament } from '../types/tournament';

interface TournamentContextValue {
  tournament: Tournament;
}

const TournamentContext = createContext<TournamentContextValue | null>(null);

interface TournamentProviderProps {
  children: ReactNode;
}

export const TournamentProvider: React.FC<TournamentProviderProps> = ({ children }) => {
  // Generate the 512-token tournament once
  const tournament = useMemo(() => generateTournament(512), []);

  const value: TournamentContextValue = {
    tournament,
  };

  return (
    <TournamentContext.Provider value={value}>
      {children}
    </TournamentContext.Provider>
  );
};

export const useTournament = () => {
  const context = useContext(TournamentContext);
  if (!context) {
    throw new Error('useTournament must be used within a TournamentProvider');
  }
  return context;
};